if (!customElements.get('mf-price-range')) {
  customElements.define('mf-price-range', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.low = this.querySelector('[data-range="min"]');
      this.high = this.querySelector('[data-range="max"]');
      this.limit = Number(this.high.max);
      this.format = new Intl.NumberFormat(this.dataset.locale || 'en-GB', {
        style:'currency', currency:this.dataset.currency || 'GBP'
      });
      this.addEventListener('input', event => this.update(event.target));
      this.closest('form')?.addEventListener('submit', () => {
        // Do not apply a price filter when its bounds are unchanged.
        this.low.disabled = Number(this.low.value) === 0;
        this.high.disabled = Number(this.high.value) === this.limit;
      });
      this.update();
    }
    update(changed) {
      if (Number(this.low.value) > Number(this.high.value)) {
        if (changed === this.low) this.low.value = this.high.value;
        else this.high.value = this.low.value;
      }
      const low = Number(this.low.value), high = Number(this.high.value);
      this.style.setProperty('--range-min', (this.limit ? low / this.limit * 100 : 0) + '%');
      this.style.setProperty('--range-max', (this.limit ? high / this.limit * 100 : 100) + '%');
      this.low.style.zIndex = low >= this.limit * .95 ? '2' : '0';
      this.low.setAttribute('aria-valuemax', high);
      this.high.setAttribute('aria-valuemin', low);
      for (const [key, input] of [['min',this.low],['max',this.high]]) {
        const label = this.format.format(Number(input.value));
        this.querySelector('[data-range-output="' + key + '"]').textContent = label;
        input.setAttribute('aria-valuetext', label);
      }
    }
  });
}
